import de from 'i18n/de';
import en from 'i18n/en';
import fr from 'i18n/fr';

export default {
	en: { translation: en },
	fr: { translation: fr },
	de: { translation: de },
};
